import React from "react";
import { ListGroup, ListGroupItem } from "reactstrap";
import Icon from "@fortawesome/react-fontawesome";
import { faAt, faUser, faMobileAlt } from "@fortawesome/fontawesome-free-solid";
import { isFunction } from "lodash";

const CustomerListItem = ({ customer, children }) => {
  return (
    <ListGroupItem>
      <div className="row justify-content-between align-items-center">
        <div className="col-lg-9 col-sm-8">
          <div className="row">
            <div className="col-sm-12 col-lg-4">
              <label>
                <Icon icon={faUser} />{" "}
                {`${customer.first_name} ${customer.last_name}`}
              </label>
            </div>
            {customer.email && (
              <div className="col-sm-12 col-lg-5">
                <label>
                  <Icon icon={faAt} /> {customer.email}
                </label>
              </div>
            )}
            {customer.phone_number && (
              <div className="col-sm-12 col-lg-3">
                <label>
                  <Icon icon={faMobileAlt} /> {customer.phone_number}
                </label>
              </div>
            )}
          </div>
        </div>
        {children && <div className="col-lg-3 col-sm-4">{children}</div>}
      </div>
    </ListGroupItem>
  );
};

const CustomerList = ({ customers, children }) => {
  return (
    <ListGroup flush>
      {customers.map((customer, index) => (
        <CustomerListItem key={customer.id || index} customer={customer}>
          {isFunction(children) && children({ customer })}
        </CustomerListItem>
      ))}
    </ListGroup>
  );
};

export default CustomerList;
